// ** MUI Imports
import type { ThemeOptions } from '@mui/material/styles'
import { darkThemeOptions, lightThemeOptions } from 'src/theme'

const UserThemeOptions = (mode: 'light' | 'dark' | 'semi-dark'): ThemeOptions =>
  mode === 'dark' ? darkThemeOptions : lightThemeOptions

export default UserThemeOptions
